import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const getApplications = createAsyncThunk("application/get", async (values, { rejectWithValue }) => {
  const queryParams = [];
  if (values?.jobId) queryParams.push(`jobId=${values.jobId}`);
  if (values?.userId) queryParams.push(`userId=${values.userId}`);
  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return makeRequest(`/applications${queryString}`, "GET", values, rejectWithValue);
});

export const createApplication = createAsyncThunk("application/create", async (values, { rejectWithValue }) => makeRequest("/applications", "POST", values, rejectWithValue));

export const patchApplication = createAsyncThunk("application/patch", async (values, { rejectWithValue }) => makeRequest(`/applications/${values.id}`, "PATCH", values, rejectWithValue));
